import { Button, Form, Modal, Slider } from "antd";
import { useState, useMemo, useEffect } from "react";
import { applyFixedDeposit } from "../ApiServices/Apifun";
import { dispatchtoast } from "../Utils";
import ReportDrawer from "./ReportDrawer";
import Content from "./ReceiptContent";

const FdCalculator = ({
  selectedPlan,
  maxAmount,
  minAmount,
  maxTenure,
  minTenure,
}) => {
  const minTenureMonths = Number(minTenure);
  const maxTenureMonths = Number(maxTenure);
  const [principal, setPrincipal] = useState(minAmount);
  const [rate, setRate] = useState(7);
  const [tenure, setTenure] = useState(minTenure);
  const [applyModalOpen, setApplyModalOpen] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const compounding = 4;
  const [PaybillResult, setPaybillResult] = useState({
    data: null,
    transaction_id: null,
  });
  const [openReceiptDrawer, setOpenReceiptDrawer] = useState(false);

  const [form] = Form.useForm();
  useEffect(() => {
    if (selectedPlan) {
      setRate(selectedPlan.interest_rate);
      setTenure(selectedPlan.min_tenure_months);
    }
  }, [selectedPlan]);

  const maturityAmount = useMemo(() => {
    const P = Number(principal);
    const r = Number(rate) / 100;
    const t = Number(tenure) / 12;
    const n = compounding;

    const A = P * Math.pow(1 + r / n, n * t);
    return A.toFixed(2);
  }, [principal, rate, tenure]);

  const interestEarned = (maturityAmount - principal).toFixed(2);
  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-IN", {
      maximumFractionDigits: 2,
    }).format(value);
  };

  const handleApplyFD = () => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("amount", principal);
    formdata.append("tenure", tenure);
    applyFixedDeposit(formdata)
      .then((res) => {
        console.log("FULL RESPONSE:", res.msg);

        if (res.status) {
          console.log(res.msg);
          dispatchtoast(res.msg);
          setApplyModalOpen(false);
          setBtnLoading(false);
          setPaybillResult({
            data: {
              "FD Number": res.fd_no,
              "Maturity Date": res.maturity_date,
              "Maturity Amount": res.maturity_amount,
            },
            transaction_id: res.fd_no,
          });
          setOpenReceiptDrawer(true);
        } else {
          console.log(res.msg);

          setApplyModalOpen(true);
          dispatchtoast(res.msg, true);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  useEffect(() => {
    if (applyModalOpen) {
      form.setFieldsValue({
        amount: principal,
        tenure: tenure,
      });
    }
  }, [applyModalOpen, principal, tenure, form]);
  return (
    <div className="bg-white shadow-xl rounded-2xl p-6 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
        FD Calculator
      </h2>

      <div className="mb-4">
        <label className="text-gray-500 text-sm">Total Investment</label>
        <div className="mt-4">
          <Slider
            min={Number(minAmount)}
            max={Number(maxAmount)}
            value={principal}
            onChange={(value) => setPrincipal(value)}
            tooltip={{
              formatter: (value) => `₹ ${value.toLocaleString("en-IN")}`,
            }}
          />
        </div>

        <div className="text-right text-sm text-gray-600 mt-1">
          ₹ {principal.toLocaleString("en-IN")}
        </div>
        {/* <input
          type="number"
          min={minAmount}
          max={maxAmount}
          value={principal}
          onChange={(e) => setPrincipal(e.target.value)}
          className="w-full h-14 mt-1 px-4 text-2xl font-semibold rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary outline-none"
        /> */}
      </div>

      <div className="grid grid-cols-1  gap-4">
        {/* <div className="mb-4">
          <label className="text-gray-500 text-sm">Interest Rate (%)</label>
          <input
            type="number"
            min="1"
            value={rate}
            onChange={(e) => setRate(e.target.value)}
            className="w-full h-12 mt-1 px-4 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary outline-none"
          />
        </div> */}
        <div className="mb-6">
          <label className="text-gray-500 text-sm">Tenure (Months)</label>

          <div className="mt-4">
            <Slider
              min={minTenureMonths}
              max={maxTenureMonths}
              value={tenure}
              onChange={(value) => setTenure(value)}
              tooltip={{
                formatter: (value) => `${value} Months`,
              }}
            />
          </div>

          <div className="text-right text-sm text-gray-600 mt-1">
            {tenure} Months
          </div>
        </div>
      </div>

      <div className="bg-gray-50 rounded-xl p-5 space-y-3">
        <div className="flex justify-between">
          <span className="text-gray-500">Invested Amount</span>
          <span className="font-semibold">₹ {formatCurrency(principal)}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Interest Rate</span>
          <span className="font-semibold text-green-600"> {rate}%</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-500">Interest Earned</span>
          <span className="font-semibold text-green-600">
            ₹ {formatCurrency(interestEarned)}
          </span>
        </div>

        <div className="flex justify-between text-lg">
          <span className="font-semibold text-gray-700">Estimated Return</span>
          <span className="font-bold text-primary">
            ₹ {formatCurrency(maturityAmount)}
          </span>
        </div>

        <button
          onClick={() => setApplyModalOpen(true)}
          className="mt-4 w-full bg-primary text-white py-3 rounded-xl font-semibold hover:bg-black transition-all duration-300 shadow-md hover:shadow-lg"
        >
          Apply
        </button>
      </div>
      {applyModalOpen && (
        <Modal
          open={applyModalOpen}
          onCancel={() => setApplyModalOpen(false)}
          footer={null}
        >
          <h2 className="text-xl font-semibold mb-4">Apply for FD</h2>

          <Form
            form={form}
            layout="vertical"
            // initialValues={{
            //   amount: principal,
            //   tenure: tenure,
            // }}
            onFinish={handleApplyFD}
          >
            <Form.Item
              label="Amount"
              name="amount"
              rules={[
                {
                  required: true,
                  message: "Please input the investment amount!",
                },
                // {
                //   max: minAmount,
                //   message: `Minimum amount is ₹ ${formatCurrency(minAmount)}`,
                // },
                // {
                //   max: maxAmount,
                //   message: `Maximum amount is ₹ ${formatCurrency(maxAmount)}`,
                // },
              ]}
            >
              <input
              disabled
                type="number"
                min={minAmount}
                max={maxAmount}
                value={principal}
                onChange={(e) => setPrincipal(e.target.value)}
                className="w-full mt-1 px-4 text-2xl text-gray-500 font-semibold bg-gray-200 rounded-xl border border-none focus:ring-2 focus:ring-primary outline-none"
              />
            </Form.Item>

            <Form.Item
              label="Tenure (Months)"
              name="tenure"
              rules={[
                { required: true, message: "Please input the tenure!" },
                // {
                //   max: minTenureMonths,
                //   message: `Minimum tenure is ${minTenureMonths} months`,
                // },
                // {
                //   max: maxTenureMonths,
                //   message: `Maximum tenure is ${maxTenureMonths} months`,
                // },
              ]}
            >
              <input
              disabled
                type="number"
                min={minTenureMonths}
                max={maxTenureMonths}
                value={tenure}
                onChange={(e) => setTenure(e.target.value)}
                className="w-full mt-1 px-4 text-2xl text-gray-500  font-semibold bg-gray-200 rounded-xl border border-none focus:ring-2 focus:ring-primary outline-none"
              />
            </Form.Item>
            <Form.Item>
              <button
                onLoad={btnLoading}
                disabled={!form.isFieldsTouched(true)}
                onClick={() => setApplyModalOpen(true)}
                className="mt-4 w-full bg-primary text-white py-3 rounded-xl font-semibold hover:bg-black transition-all duration-300 shadow-md hover:shadow-lg"
              >
                {btnLoading ? "Processing..." : "Apply"}
              </button>
            </Form.Item>
          </Form>
        </Modal>
      )}
      {openReceiptDrawer && (
        <ReportDrawer
          title={"Receipt"}
          open={openReceiptDrawer}
          setOpen={setOpenReceiptDrawer}
          content={<Content data={PaybillResult} />}
        />
      )}
    </div>
  );
};

export default FdCalculator;
